// Booking channels shared by the statistics screens: the back classifies every booking as Web, App or
// Mostrador / carga manual (organizer-loaded) and answers per-channel counts and revenue.

export const CHANNELS = [
  { key: "web", label: "Web", color: "#2a78d6", ink: "#ffffff" },
  { key: "app", label: "App", color: "#eb6834", ink: "#111827" },
  { key: "desk", label: "Mostrador / carga manual", color: "#1baf7a", ink: "#111827" },
];

/**
 * One entry per channel with its share of the bookings (null when there are none). `countKey` names the
 * count in the response (`reservations` for courts, `appointments` for Beauty); the entry carries it
 * both under that name and as `count`, which is what the shared ChannelPanel reads.
 */
export const channelShares = (channels, countKey = "reservations") => {
  const total = CHANNELS.reduce((acc, c) => acc + (channels?.[c.key]?.[countKey] ?? 0), 0);
  return CHANNELS.map((c) => {
    const count = channels?.[c.key]?.[countKey] ?? 0;
    return { ...c, [countKey]: count, count, revenue: channels?.[c.key]?.revenue ?? 0, share: total ? count / total : null };
  });
};
